require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-lauren-sauser.json") })
        }
      }, "path---blog-author-lauren-sauser");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-lauren-sauser!./.cache/json/blog-author-lauren-sauser.json
// module id = 673
// module chunks = 231608221292675